import React from "react";
import CabiMascot from "./CabiMascot";

/**
 * Cabi coach bubble — mascot avatar + speech bubble. `side` squares the
 * corner of the bubble toward the avatar ("start" | "end") and mirrors
 * automatically in RTL because it's expressed with logical properties.
 */
export default function CabiBubble({
  text,
  mood = "idle",
  side = "start",
  theme = "dark",
  size = 60,
  className = "",
}) {
  const onLight = theme === "light";
  const cornerClass = side === "start" ? "rounded-ss-md" : "rounded-se-md";

  return (
    <div className={`flex items-start gap-3 ${side === "end" ? "flex-row-reverse" : ""} ${className}`}>
      <div
        className="shrink-0 rounded-full flex items-center justify-center"
        style={{
          width: size,
          height: size,
          background: "linear-gradient(160deg, #FFB47A 0%, #EE5F2B 100%)",
        }}
      >
        <CabiMascot mood={mood} size={size * 0.78} />
      </div>
      {text && (
        <div
          className={`flex-1 rounded-2xl px-4 py-3 font-body font-bold text-[14px] ${cornerClass}`}
          style={
            onLight
              ? { background: "#fff", border: "1px solid #F0E3D6", color: "#2A2620" }
              : { background: "rgba(255,255,255,.22)", color: "#fff" }
          }
        >
          {text}
        </div>
      )}
    </div>
  );
}
